import { render, staticRenderFns } from "./MuzekkereAdresBilgileriList.vue?vue&type=template&id=65659eec"
import script from "./MuzekkereAdresBilgileriList.vue?vue&type=script&lang=ts"
export * from "./MuzekkereAdresBilgileriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports